export default "__VITE_ASSET__BNlvIfaD__"